import React, { useEffect, useState } from "react";
import SiteList from "../components/siteList";
import SiteProjectHeader from "../components/siteProjectHeader";
import {
  ADMIN_ADD_SITE,
  ADMIN_SITE_PROJECTS_LIST,
  ADMIN_PROJECTS_LIST,
  ACCESS_DENIED,
  ADMIN_VIEW_SITE,
} from "../../../../constant/routeContant";
import { useDispatch, useSelector } from "react-redux";
import * as siteAction from "../../../../redux/storm-water/actions/siteAction";
import { LOGIN_ORG_ID, ORG_ID, PAGE_SIZE } from "../../../../constant/constant";
import * as clientAction from "../../../../redux/actions/clientAction";
import { checkPrivileges } from "../../../../utils/rolesHelper";
import { useLocation, useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { getPreviousRoute } from "../../../../utils/routeTracker";

function SiteListContainer() {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [shouldRestoreState, setShouldRestoreState] = useState(false);
  const dataHeader = {
    title: LOGIN_ORG_ID() == 1 ? "Sites and Projects" : "Projects",
    btnLink: ADMIN_ADD_SITE,
    menu: [
      {
        route: ADMIN_SITE_PROJECTS_LIST,
        text: "Sites",
        isshow: checkPrivileges([12, 108, 109, 110]),
      },
      {
        route: ADMIN_PROJECTS_LIST,
        text: "Projects",
        isshow: checkPrivileges([12, 111, 112, 113]),
      },
    ],
  };
  if (checkPrivileges([12, 108, 109])) {
    dataHeader.btnText = "Add Site";
  }
  // LOGIN_ORG_ID() == 1 &&
  //   checkPrivileges([12, 108, 109, 110]) &&
  //   dataHeader.menu.unshift({
  //     route: ADMIN_SITE_PROJECTS_LIST,
  //     text: "Sites",
  //   });
  const siteListData = useSelector((state) => state.siteListData);

  const siteLists = (data, clientKeyValue = null) => {
    dispatch(siteAction.siteList(data));

    const updateData = {
      ...data,
      autoserchkey:
        typeof clientKeyValue === "object" && clientKeyValue !== null
          ? clientKeyValue
          : (siteListData?.filterObj?.autoserchkey ?? { key: "", value: "" }),
    };

    dispatch(siteAction.getSitesandProjectsFilterObj(updateData));
  };

  const defaultData = {
    page: 1,
    pageSize: PAGE_SIZE,
    customerId: ORG_ID(),
    startDate: "",
    endDate: "",
    search: "",
    status: "",
    autoserchkey: { key: "", value: "" },
  };
  useEffect(() => {
    const previousRoute = getPreviousRoute();
    const preserveRoutes = [
      ADMIN_SITE_PROJECTS_LIST,
      ADMIN_VIEW_SITE,
      ADMIN_ADD_SITE,
    ];
    const isFromPreserveRoute =
      previousRoute &&
      preserveRoutes.some((r) => previousRoute.startsWith(r)) &&
      sessionStorage.getItem("siteListPreserveState") === "true";
    sessionStorage.removeItem("siteListPreserveState");

    if (isFromPreserveRoute && siteListData?.filterObj) {
      setShouldRestoreState(true);
      siteLists(siteListData.filterObj);
    } else {
      setShouldRestoreState(false);
      siteLists(defaultData);
    }
  }, []);
  const searchAllClientsReducerData = useSelector(
    (state) => state.searchAllClientsReducerData,
  );
  const autoSearchDataLoading = searchAllClientsReducerData.isLoading;

  const searchClient = (searchText) => {
    dispatch(clientAction.searchAllClients(searchText));
  };

  return (
    <>
      {checkPrivileges([12, 108, 109, 110]) ? (
        <>
          <SiteProjectHeader dataHeader={dataHeader} />
          <SiteList
            siteLists={siteLists}
            siteListData={siteListData}
            isLoading={siteListData.isLoading}
            searchClient={searchClient}
            autoSearchDataLoading={autoSearchDataLoading}
            searchAllClientsReducerData={searchAllClientsReducerData}
            siteListDatas={siteListData}
            shouldRestoreState={shouldRestoreState}
          />
          <ToastContainer />
        </>
      ) : (
        navigate(ACCESS_DENIED)
      )}
    </>
  );
}

export default SiteListContainer;
